import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import Loader from './Loader';
import { CalendarMonth } from '@mui/icons-material';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const BASE_FILE = process.env.REACT_APP_FILE_BASE_URL || "https://appserver.tbzmc.com";

const LatestRetrainings = ({ limit = 5 }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchItems = async () => {
      try {
        setLoading(true);
        let data = [];
        try {
          const res = await api.get(`/retraining?limit=${limit}`);
          data = res.data || [];
        } catch (err) {
          const res2 = await api.get('/retraining');
          data = (res2.data || []).slice(0, limit);
        }
        setItems(data);
      } catch (e) {
        console.error('Error loading retrainings', e);
        setItems([]);
      } finally { setLoading(false); }
    };
    fetchItems();
  }, [limit]);

  if (loading) return <Loader />;
  if (!items || items.length === 0) return null;

  return (
    <div className="mb-3 mt-4">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="mb-0">جدیدترین بازآموزی‌ها</h6>
      </div>

      <div style={{ display: 'flex', gap: 12, overflowX: 'auto', paddingBottom: 8, WebkitOverflowScrolling: 'touch' }}>
        {items.map(item => (
          <a
            target="_blank"
            href={item.registrationLink}
            key={item._id}
            style={{ flex: '0 0 220px' }}>
            <div className="card mb-0">
              {item.poster && (
                <img src={`${BASE_FILE}/uploads/documents/${item.poster}`} alt={item.title} style={{ height: 120, objectFit: 'cover', width: '100%', borderTopRightRadius: 15, borderTopLeftRadius: 15 }} />
              )}
              <div className="card-body p-2">
                <h6 className="small mb-1" style={{
                  height: 40
                }}>{item.title}</h6>
                <div className="size-10 text-muted d-flex align-items-center" ><CalendarMonth sx={{ fontSize: 14 }} className="me-1" />{item.date}</div>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default LatestRetrainings;
